
export enum EQuoteStatus {
  Pending = "Pending",
  Draft = "Draft",
  Sent = "Sent",
  Approved = "Approved",
  Credited = "Credited",
  Voided = "Voided",
  Payment = "Payment",
  Paid = "Paid",
  Inactive = "Inactive"
}
